import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { Editor } from "components/shared/Editor";

const PrivancyTerms = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [sliders, setSliders] = useState([]);
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "privacy",
        slug: "data",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    dispatch(
      editSection({ slug: "data", page: "privacy", data: { section: data } })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"privacyTerms"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col md={12}>
                <Row>
                  <Col xs="12" md="6">
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"content"} /> (
                        <FormattedMessage id="arabic" />)
                      </h5>

                      <Controller
                        control={control}
                        name={`content.ar`}
                        render={({ field: { value, onChange } }) => (
                          <Editor
                            type="text"
                            initialValue={value}
                            className={`form-control form-outline`}
                            onChange={(_, editor) => {
                              const data = editor.getContent();
                              onChange(data);
                            }}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" md="6">
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"content"} /> (
                        <FormattedMessage id="english" />)
                      </h5>

                      <Controller
                        control={control}
                        name={`content.en`}
                        render={({ field: { value, onChange } }) => (
                          <Editor
                            type="text"
                            initialValue={value}
                            className="form-control form-outline"
                            onChange={(_, editor) => {
                              const data = editor.getContent();
                              onChange(data);
                            }}
                          />
                        )}
                      />
                    </div>
                  </Col>
                </Row>
                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivancyTerms;
